/**
 * shiftcam-slideshow-tab-grid.js
 *
 * Powers <shiftcam-slide-tabs> in sections/shiftcam-slideshow-tab-grid.liquid.
 * Plain ARIA tabs pattern - no dependency on the theme's slideshow-element /
 * slideshow-words, since this section doesn't use a Flickity-backed carousel.
 *
 * - Click a pill -> activates the matching panel (grid + slide caption), hides the rest.
 * - Arrow Left/Right on a focused pill moves focus + selection to the next/previous pill.
 * - shopify:block:select -> activates that block's panel even if currently hidden,
 *   so selecting a slide in the theme editor sidebar actually shows it.
 */
class ShiftcamSlideTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-pill-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-pill-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.index));
    });

    this.addEventListener('keydown', this.onKeydown.bind(this));

    this.addEventListener('shopify:block:select', (event) => {
      const panel = this.panels.find((p) => p === event.target);
      if (panel) this.select(panel.dataset.index);
    });
  }

  select(index) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.index === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.index !== index;
    });
  }

  onKeydown(event) {
    if (!event.target.matches('[data-pill-tab]')) return;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    const currentIndex = this.tabs.indexOf(event.target);
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const nextTab = this.tabs[(currentIndex + step + this.tabs.length) % this.tabs.length];

    event.preventDefault();
    nextTab.focus();
    this.select(nextTab.dataset.index);
  }
}

if (!customElements.get('shiftcam-slide-tabs')) {
  customElements.define('shiftcam-slide-tabs', ShiftcamSlideTabs);
}